// Import libraries
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
